import { Controller } from "@hotwired/stimulus"

// SOKA section form: the SOKA details show while "Bauarbeiter (SOKA)" is ticked,
// the end date of the period while it is unticked. Hidden fields are disabled too,
// so an end date never travels with a ticked flag.
export default class extends Controller {
  static targets = ["sokaSettings", "endSettings", "checkbox"]

  connect() {
    this.updateVisibility()
  }

  toggleFields() {
    this.updateVisibility()
  }

  updateVisibility() {
    if (!this.hasCheckboxTarget) return

    const checked = this.checkboxTarget.checked
    if (this.hasSokaSettingsTarget) this.sokaSettingsTarget.classList.toggle("hidden", !checked)
    if (this.hasEndSettingsTarget) {
      this.endSettingsTarget.classList.toggle("hidden", checked)
      this.endSettingsTarget.querySelectorAll("input").forEach((input) => {
        input.disabled = checked
      })
    }
  }
}
